import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import "./login.css";
// Adjust the path below based on where this file lives:
import logo from "../../assets/images/logo.png";
import { checkEmail } from "../../services/LoginService";

export default function Login() {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [touched, setTouched] = useState({ fullName: false, email: false });
  const [status, setStatus] = useState("idle"); // "idle" | "sending" | "sent" | "error"
  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());
  const isValidName = (v) =>
    v.trim().split(/\s+/).length >= 2 && v.trim().length >= 4;

  const formValid = isValidEmail(email) && isValidName(fullName);
  const navigate = useNavigate();

  const handleLogin = () => {
    // Add your login logic here
    navigate("/intro");
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (!formValid || status === "sending") return;
    setStatus("sending");

    try {
      const result = await checkEmail(email);

      if (result.success) {
        // Save info locally
        sessionStorage.setItem("login_email", email);
        sessionStorage.setItem("login_name", fullName);

        // Navigate to intro page
        navigate("/intro");
      } else {
        setStatus("error");
      }
    } catch (err) {
      console.error("Login error:", err);
      setStatus("error");
    }
  }

  return (
    <main className="login-page">
      <section
        className="login-card"
        role="dialog"
        aria-labelledby="loginTitle"
      >
        <img className="login-logo" src={logo} alt="Company logo" />
        <p id="loginTitle" className="login-title">
          Log in to Solvo Global
        </p>

        {status === "sent" ? (
          <div className="notice success" role="status">
            We sent a sign-in link to <strong>{email}</strong>. Check your
            inbox.
          </div>
        ) : (
          <form className="login-form" onSubmit={handleSubmit} noValidate>
            <div className="field">
              <label htmlFor="fullName">Full name</label>
              <input
                id="fullName"
                name="fullName"
                type="text"
                inputMode="text"
                autoComplete="name"
                placeholder="e.g. Ada Lovelace"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                onBlur={() => setTouched((t) => ({ ...t, fullName: true }))}
                aria-invalid={touched.fullName && !isValidName(fullName)}
                aria-describedby="nameHelp"
              />
              {touched.fullName && !isValidName(fullName) && (
                <p id="nameHelp" className="error">
                  Please enter your first and last name.
                </p>
              )}
            </div>

            <div className="field">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                inputMode="email"
                autoComplete="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={() => setTouched((t) => ({ ...t, email: true }))}
                aria-invalid={touched.email && !isValidEmail(email)}
                aria-describedby="emailHelp"
              />
              {touched.email && !isValidEmail(email) && (
                <p id="emailHelp" className="error">
                  Enter a valid email address.
                </p>
              )}
            </div>

            <button
              type="submit"
              className={`btn ${status === "sending" ? "is-loading" : ""}`}
              disabled={!formValid || status === "sending"}
              style={{ margin: "0px" }}
            >
              {status === "sending" ? "Checking account..." : "Log in"}
            </button>
          </form>
        )}

        {status === "error" && (
          <div className="notice error" role="alert">
            This user has already sent a video.
          </div>
        )}
      </section>
    </main>
  );
}
